<script setup>
import { reactive } from 'vue'

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const state = reactive({

})
</script>

<template>
  <VContainer>
    <div class="fo-textbtn-area-holder">
      <VCard class="mb-6">
        <VCardText>
          <VRow>
            <VCol
              cols="12"
              md="12"
            >
              <div class="fo-textbtn-area">
                <RouterLink
                  to="/settings/text"
                  class=""
                >
                  <VBtn>
                    TEXT
                  </VBtn>
                </RouterLink>
                <RouterLink
                  to="/settings/identity"
                  class=""
                >
                  <VBtn class="fo-grey">
                    IDENTITY
                  </VBtn>
                </RouterLink>
              </div>
            </VCol>
          </VRow>
        </VCardText>
      </VCard>
    </div>
  </VContainer>
</template>
